export default __webpack_public_path__ + "static/media/readingWorld.5b11af24.png";